export const LEARN_MY_COURSES_SLUG = 'learn-my-courses'
export const LEARN_CATALOG_SLUG = 'learn-catalog'
export const LEARN_DASHBOARD_SLUG = 'learn-dashboard'
export const LEARN_CALENDAR_SLUG = 'learn-calendar'
export const LEARN_EMAIL_ANSWER_SLUG = 'learn-email-answer'
